<template>
    <div :id="widgetId" class="vrm-gridster__item">
        <summary-widget
            v-if="widget.type === WIDGET_TYPE.SUMMARY"
            :widget-id="widget.idWidget"
            :icon-class="widget.iconClass"
            :custom-name="widget.customName"
            :installation="installation"
            :code="widget.code"
            :title="widget.name"
            :instance="widget.instance"
            :is-mobile="isMobile"
            :has-touch-enabled="hasTouchEnabled"
            :size="widget.size"
            :range="range"
        />
        <gps-widget
            v-else-if="widget.type === WIDGET_TYPE.GPS"
            :widget-id="widget.idWidget"
            :icon-class="widget.iconClass"
            :custom-name="widget.customName"
            :installation="installation"
            :range="range"
            :is-mobile="isMobile"
            :has-touch-enabled="hasTouchEnabled"
            :size="widget.size"
            :item-state="widget.gridItemState"
        />
        <VEConfigureWidget
            v-else-if="widget.type === WIDGET_TYPE.VE"
            :widget-id="widget.idWidget"
            :icon-class="widget.iconClass"
            :custom-name="widget.customName"
            :installation="installation"
            :is-mobile="isMobile"
            :has-touch-enabled="hasTouchEnabled"
            :size="widget.size"
        />
        <graph-widget
            v-else-if="widget.type === WIDGET_TYPE.GRAPH"
            class="vrm-widget__graph-content v-sync-graph"
            :widget-id="widget.idWidget"
            :icon-class="widget.iconClass"
            :custom-name="widget.customName"
            :loading="loading"
            :range="range"
            :installation="installation"
            :zoomstate="zoomstate"
            :data="graphData"
            :code="widget.code"
            :title="widget.name"
            :instance="widget.instance"
            :is-mobile="isMobile"
            :has-touch-enabled="hasTouchEnabled"
            :size="widget.size"
            :item-state="widget.gridItemState"
            :persistent-mode="persistentMode"
        />
        <graph-custom-widget
            v-else-if="widget.type === WIDGET_TYPE.CUSTOM"
            class="vrm-widget__graph-content v-sync-graph"
            :widget-id="widget.idCustomWidget"
            :loading="loading"
            :range="range"
            :installation="installation"
            :zoomstate="zoomstate"
            :data="customGraphData"
            :series="widget.series"
            :title="widget.name"
            :is-mobile="isMobile"
            :is-advanced-view="true"
            :y-axis-properties="widget.yAxisProperties"
            :has-touch-enabled="hasTouchEnabled"
            :size="widget.size"
            :item-state="widget.gridItemState"
            :persistent-mode="persistentMode"
            :can-be-updated="widget.canBeUpdated"
        />
        <state-widget
            v-else-if="widget.type === WIDGET_TYPE.STATE"
            class="vrm-widget__graph-content v-sync-graph"
            :widget-id="widget.idWidget"
            :icon-class="widget.iconClass"
            :custom-name="widget.customName"
            :loading="loading"
            :zoomstate="zoomstate"
            :installation="installation"
            :code="widget.code"
            :title="widget.name"
            :range="range"
            :instance="widget.instance"
            :is-mobile="isMobile"
            :has-touch-enabled="hasTouchEnabled"
            :size="widget.size"
            :item-state="widget.gridItemState"
            :persistent-mode="persistentMode"
        />
        <summary-graph-widget
            v-else-if="widget.type === WIDGET_TYPE.SUMMARY_GRAPH"
            class="vrm-widget__graph-content v-sync-graph"
            :widget-id="widget.idWidget"
            :icon-class="widget.iconClass"
            :custom-name="widget.customName"
            :loading="loading"
            :range="range"
            :installation="installation"
            :zoomstate="zoomstate"
            :data="graphData"
            :code="widget.code"
            :title="widget.name"
            :instance="widget.instance"
            :is-mobile="isMobile"
            :has-touch-enabled="hasTouchEnabled"
            :size="widget.size"
            :item-state="widget.gridItemState"
            :persistent-mode="persistentMode"
        />
        <vrm-widget-skeleton v-else />
        <div class="vrm-gridster__resize-cover"></div>
    </div>
</template>

<script>
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { WIDGET_TYPE } from '@/vue/components/shared/widget/codeToType';
import GraphCustomWidget from '@/vue/components/shared/widget/GraphCustomWidget.vue';
import GraphWidget from '@/vue/components/shared/widget/GraphWidget.vue';
import StateWidget from '@/vue/components/shared/widget/StateWidget.vue';
import VrmWidgetSkeleton from '@/vue/components/shared/grid/VrmWidgetSkeleton.vue';
import SummaryGraphWidget from '@/vue/components/shared/widget/SummaryGraphWidget.vue';
import SummaryWidget from '@/vue/components/shared/widget/SummaryWidget.vue';
import GpsWidget from '@/vue/components/shared/widget/GpsWidget.vue';
import VEConfigureWidget from '@/vue/components/shared/widget/VEConfigureWidget.vue';

@Component({
    components: {
        GpsWidget,
        SummaryWidget,
        SummaryGraphWidget,
        VrmWidgetSkeleton,
        StateWidget,
        GraphWidget,
        GraphCustomWidget,
        VEConfigureWidget,
    },
})
export default class VrmWidget extends Vue {
    @Prop({ type: Object, default: () => {} })
    widget;
    @Prop({ type: Boolean, default: false })
    isMobile;
    @Prop({ type: Object, default: null })
    range;
    @Prop({ type: Object, default: null })
    zoomstate;
    @Prop({ type: Object, default: null })
    installation;
    @Prop({ type: Object, default: () => {} })
    graphData;
    @Prop({ type: Object, default: () => {} })
    customGraphData;
    @Prop({ type: Boolean, default: false })
    loading;
    @Prop({ type: Boolean, default: false })
    hasTouchEnabled;
    @Prop({ type: Boolean, default: false })
    persistentMode;

    WIDGET_TYPE = WIDGET_TYPE;

    @Watch('widgetActive')
    onWidgetActiveChange(newValue) {
        if (newValue === false) {
            this.$emit('widget-disable', this.widget.uniqueIdentifier);
        }
    }

    get widgetActive() {
        return this.widget.gridItemState.active;
    }

    get widgetId() {
        return this.widget.idCustomWidget
            ? `widget-${this.widget.idCustomWidget}`
            : `widget-${this.widget.idWidget}`;
    }
}
</script>
